module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 39